import { render, staticRenderFns } from "./catCalendarAFS.vue?vue&type=template&id=21b20e23"
import script from "./catCalendarAFS.vue?vue&type=script&lang=js"
export * from "./catCalendarAFS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports